module.exports = __webpack_public_path__ + "img/i_notice.36aff058.svg";